import {createRouter, createWebHashHistory, isNavigationFailure, NavigationFailureType} from 'vue-router'
import Recommendation from '../views/networkers/Recommendation.vue'
import Chat from '../views/Chat.vue'
import Contacts from '../views/networkers/Contacts.vue'
import OwnProfile from '../views/Profile-Own.vue'
import EntryPoint from "../views/EntryPoint";
import localStorageHelper from "../localstorage/local-storage";
import themes from '../themes/themes-helper';
import i18n from '../i18n';
import ProfileOthers from "../views/Profile-Others";
import Appointments from "../views/appointments/Appointments";
import Groups from '../views/Groups.vue';
import VideoGroup from '../views/VideoGroup.vue';
import VideoCollection from '../views/videoCollection/VideoCollection';
import {isDefined} from "../utils";
import Companies from '../views/companies/Companies';
import Corporates from '../views/companies/Corporates';
import langHelper from "../locales/lang-helper";
import {useToast} from "vue-toastification";
import Dashboard from "@/views/Dashboard.vue";


export let initialPath = null;

export let componentHistory = [];

function addComponentToHistory(component) {
    componentHistory.push(component);
    if (componentHistory.length > 3) {
        componentHistory.shift();
    }
}

const routes = [
    {
        path: '/',
        name: 'EntryPoint',
        component: EntryPoint
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard
    },
    {
        path: '/home',
        name: 'Home',
        component: Recommendation
    },
    {
        path: '/profile',
        name: 'Profile',
        component: OwnProfile
    },
    {
        path: '/profile/:userId',
        name: 'ProfileOthers',
        component: ProfileOthers
    }
]


const enableGroups = process.env.VUE_APP_ENABLE_GROUPS === 'true';
const enableCompanies = process.env.VUE_APP_ENABLE_COMPANIES === 'true';
const enableCorporates = process.env.VUE_APP_ENABLE_CORPORATES === 'true';
const enableVideoCollection = process.env.VUE_APP_ENABLE_VIDEO_COLLECTION === 'true';
const enableAppointments = process.env.VUE_APP_ENABLE_APPOINTMENTS === 'true';
const onlyAppointments = process.env.VUE_APP_ONLY_APPOINTMENTS === 'true';
const isUsingOAuth = process.env.VUE_APP_OAUTH_URL != null && process.env.VUE_APP_OAUTH_URL.length > 0;

if (!onlyAppointments) {
    routes.push({
        path: '/contacts',
        name: 'Contacts',
        component: Contacts
    }, {
        path: '/chat/:userId?',
        name: 'Chat',
        component: Chat
    }, {
        path: '/contact-requests',
        name: 'ContactRequests',
        component: Chat
    });
}

if (process.env.VUE_APP_ENABLE_DASHBOARD === 'true') {
    routes.push({
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard
    },)
}

if (enableAppointments) {
    routes.push({
        path: '/appointments',
        name: 'Appointments',
        component: Appointments
    })
}

if (enableGroups) {
    routes.push({
            path: '/events',
            name: 'Groups',
            component: Groups
        },
        {
            path: '/events/:eventId',
            name: 'Group',
            component: VideoGroup
        });
}

if (enableCompanies) {
    routes.push({
        path: '/companies',
        name: 'Companies',
        component: Companies
    });
}

if (enableCorporates) {
    routes.push({
        path: '/corporates',
        name: 'Corporates',
        component: Corporates
    });
}

if (enableVideoCollection) {
    routes.push({
        path: '/content',
        name: 'VideoCollection',
        component: VideoCollection
    });
}

/* EXPO REAL */
routes.push({
    path: '/help',
    name: 'Help',
    beforeEnter(to, from, next) {
        const lang = langHelper.getCurrentLang()
        if (lang === 'de') {
            window.open('https://d2n1n6byqxibyi.cloudfront.net/asset/933560888063/video_uihps63cft3tjdedn749m6in0l?content-disposition=inline', '_blank').focus()
        } else {
            window.open('https://d2n1n6byqxibyi.cloudfront.net/asset/933560888063/video_uihps63cft3tjdedn749m6in0l?content-disposition=inline', '_blank').focus()
        }
    }
});

const router = createRouter({
    history: createWebHashHistory(),
    routes
});


const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
    return originalPush.call(this, location).then((err) => {
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
            return err;
        } else {
            if (err.to.name === 'Profile') {
                const fromThemeSelect = err.to.matched[0].instances.default.selectThemes;
                if (fromThemeSelect) {
                    err.to.matched[0].instances.default.onSelectThemesClosedByRouter();
                }
            }
        }
    });
}


router.beforeEach((to, from, next) => {

        // Internet Explorer 6-11
        let notSupported = /*@cc_on!@*/false || !!document.documentMode;

        if (!isDefined(localStorage)) {
            notSupported = true;
        }

        if (!notSupported) {

            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isAndroid = /android/i.test(userAgent);
            const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream

            // device detection and redirect when ios or android mobile device
            if (process.env.VUE_APP_MOBILE_REDIRECT_URL_EN && process.env.VUE_APP_MOBILE_REDIRECT_URL_DE) {
                if (isAndroid || isIOS) {
                    window.location = langHelper.getCurrentLang() === "de" ? process.env.VUE_APP_MOBILE_REDIRECT_URL_DE : process.env.VUE_APP_MOBILE_REDIRECT_URL_EN;
                    return;
                }
            }

            if ((!localStorageHelper.getDeviceId() || !localStorageHelper.getUserId() || !localStorageHelper.getUserConfirmed()) && to.name !== 'EntryPoint') {
                addComponentToHistory('EntryPoint');
                if (from.name !== 'EntryPoint') {
                    initialPath = window.location.hash;
                    if (initialPath) initialPath = initialPath.substring(1);

                    next({name: 'EntryPoint'});
                }
            } else {
                if (process.env.VUE_APP_MYBOOKFAIR_USER_HOST != null && process.env.VUE_APP_MYBOOKFAIR_USER_HOST.length > 0) {
                    if (!localStorageHelper.getUserCreatedManually() && localStorageHelper.getWentToMyBookFair() && localStorageHelper.getDeviceId()) {
                        themes.checkForThemeChanges();
                        localStorageHelper.deleteWentToMyBookFair();
                    }
                    const dayInMs = 86400000;
                    const currentTimeInMs = new Date().getTime();
                    if (localStorageHelper.getUserCreatedManually() === 'false' && localStorageHelper.getDeviceId() && (!localStorageHelper.getLastMyBookFairCheck() || localStorageHelper.getLastMyBookFairCheck().getTime() - currentTimeInMs > dayInMs)) {
                        themes.checkForThemeChanges();
                    }
                }

                if (isDefined(localStorageHelper.getRegistrationCompleted())) {
                    addComponentToHistory(to.name);
                    next();
                } else if (to.name === 'EntryPoint') {
                    next();
                }

            }
        } else {
            const {t} = i18n.global;
            useToast().info(t('browser-not-supported'), {
                position: 'top-center',
                onClick: () => {
                    history.back();
                }
            });
        }
    }
);

router.getParamName = function getParamName() {
    return isUsingOAuth ? 'code' : 'token';
};

router.deleteCodeParam = function deleteCodeParam() {
    console.log("deleteCodeParam");
    let urlParams = new URLSearchParams(window.location.search);
    let paramName = this.getParamName();
    console.log("deleteCodeParam paramName: " + paramName);
    const codeParam = urlParams.get(paramName);
    const loginParam = urlParams.get('login');

    if (codeParam || loginParam) {
        urlParams.delete(paramName);
        urlParams.delete('login');
        if (process.env.VUE_APP_OAUTH_TYPE == 'mbf') {
            urlParams.delete('state');
            urlParams.delete('lang');
        }
        let search = urlParams.toString();
        if (search.length > 0) {
            search = '?' + search;
        }
        let newUrl = window.location.pathname + search + window.location.hash;
        window.history.replaceState(null, null, newUrl);
    }
};

export default router
